module.exports = __webpack_public_path__ + "static/media/RPG_500.c701286e.png";